import React from 'react';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import Services from './Services';
import StyleYourWay from './StyleYourWay';
import Pricing from './Pricing';
import WhyChoose from './WhyChoose';
import SeamlessCare from './Steps';
import FAQ from './FAQ';
import Testimonials from './Review';
import AppDownloadBadges from './AppDownloadBadges';

export default function Home() {
  return (
    <div className="relative overflow-x-hidden">
      <Hero />
      <HowItWorks />
      <Services />
      <StyleYourWay />
      <Pricing />
      <WhyChoose />
      <SeamlessCare />
      <FAQ />
      <Testimonials />
      <AppDownloadBadges />
    </div>
  );
}
